<template>
    <div 
      class="notice"
      :class="appendedLevel">
        <p v-html="message"></p>
    </div>
</template>

<script>
export default {
  name: "AcNotice",
  props: {
    message: {
      type: String,
      required: true
    },
    level: {
      type: String,
      default: "info",
      validator(value) {
        const validLevels = ["success", "error", "info", "warning"];

        return validLevels.includes(value);
      }
    }
  },
  computed: {
    appendedLevel() {
      return "notice-" + this.level;
    }
  }
};
</script>



// WEBPACK FOOTER //
// admin/src/js/components/AcNotice.vue